import * as RequestParam from '../constants/RequestParam';

export function load(message: string) {
  return {
    type: RequestParam.LOADED,
    message: message,
  };
}



// WEBPACK FOOTER //
// ./src/actions/RequestParam.tsx